import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, InputBaseComponentProps, Typography } from '@mui/material';
import DefaultHypothesisValue from './DefaultHypothesisValue';
import HypothesisValue from './HypothesisValue';
import TotalCost from './TotalCost';
import HypothesisDate from './HypothesisDate';
import { StyBlock } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/PayConstantsEntryForm/helpers/StyledComponents';
import { CostPerYearT } from '../../../GVTData/helpers/hooks/gvtData';

type HypothesisEntryFormProps = {
    typeValue: 'number' | 'percentage';
    isLoading: boolean;
    title: string;
    isHrSimulationResponseFetching: boolean;
    defaultValue: number | undefined;
    value: number | undefined;
    date: string | undefined;
    onChange: (newValue: number) => void;
    onDateChange: (newDate: string) => void;
    inputProps: InputBaseComponentProps;
    totalCost: number;
    costPerYear: CostPerYearT;
};

const HypothesisEntryForm = ({
    title,
    typeValue,
    defaultValue,
    value,
    date,
    onChange,
    onDateChange,
    inputProps,
    isHrSimulationResponseFetching,
    totalCost,
    costPerYear,
    isLoading,
}: HypothesisEntryFormProps): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <StyBlock>
            <Typography variant="h4" sx={{ fontSize: '16px' }}>
                {t(title)}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <DefaultHypothesisValue
                        defaultValue={defaultValue}
                        typeValue={typeValue}
                        isLoading={isLoading}
                    />
                </Grid>

                <Grid item xs={4}>
                    <HypothesisValue
                        futureValue={value}
                        typeValue={typeValue}
                        onChange={onChange}
                        inputProps={inputProps}
                        isLoading={isLoading}
                    />
                </Grid>
                <Grid item xs={4}>
                    <HypothesisDate
                        applicationDate={date}
                        onDateChange={onDateChange}
                        isLoading={isLoading}
                    />
                </Grid>
            </Grid>
            <TotalCost
                costPerYear={costPerYear}
                totalCost={totalCost}
                label={t('humanResources.simulation.raiseCost')}
                isLoading={isLoading || isHrSimulationResponseFetching}
            />
        </StyBlock>
    );
};

export default memo(HypothesisEntryForm);
